import { Route } from 'react-router';
import * as React from 'react';

export const getRouteComponent = (index: number, props: any, componentProps?: any) => {
    let routeComponent = <Route key={`${props.path || index}`} {...props} />;

    if (props.component) {
        const Component: React.ComponentType<any> = props.component;

        routeComponent = (
            <Route key={`${props.path || index}`} {...props}>
                <Component {...componentProps}></Component>
            </Route>
        );
    }

    return routeComponent;
};
